export default {
  namespaced: true,
  state: {
    loading: false,
    settingConfig: null
  },
  mutations: {
    SET_LOADING (state, payload) {
      state.loading = payload
    },
    SET_SETTING_CONFIG (state, payload) {
      state.settingConfig = payload
    }
  },
  getters: {
    loading: state => state.loading,
    settingConfig: state => state.settingConfig
  }
}
